import { createContext, useContext } from 'react';

// Create context
const DropdownContext = createContext();

// Create a custom hook for consuming the context
const useDropdownContext = () => {
	const context = useContext(DropdownContext);
	if (!context) {
		throw new Error('useDropdownContext must be used within a DropdownProvider');
	}
	return context;
};


export { DropdownContext, useDropdownContext };